import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import {
  fetchNotifications,
  saveNotifications,
  toggleEnabled,
} from '../../features/notifications/notificationsSlice';
import { useSaveUserFilterMutation } from '../../app/services/complexFilters';
import { SettingsCard, SettingsCardHeader } from '../../components/SettingsCard';
import { FormControlLabel, Switch, Typography, Box, Tooltip, Divider } from '@mui/material';
import ComplexFilters from './ComplexFilters';

function UserProfilNotification() {
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);
  const [saveUserFilter] = useSaveUserFilterMutation();

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  useEffect(() => {
    setIsNotificationEnabled(notifications.enabled);
  }, [notifications]);

  const handleChangeNotifications = async () => {
    const newEnabled = !isNotificationEnabled;
    dispatch(toggleEnabled());
    setIsNotificationEnabled(newEnabled);

    try {
      if (newEnabled) {
        // Clear filters and save notifications in parallel
        await Promise.all([saveUserFilter([]), dispatch(saveNotifications())]);
      } else {
        await dispatch(saveNotifications());
      }
    } catch (error) {
      console.error('Error updating notifications:', error);
    }
  };

  return (
    <>
      <SettingsCard>
        <SettingsCardHeader
          title={t('userProfile.notificationPreferences')}
          subtitle={t('userProfile.notificationSubtitle')}
          tooltipText={t('userProfile.information')}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            padding: { xs: '16px', md: '24px' },
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: '12px', md: 0 },
          }}
        >
          <div>
            <Typography fontWeight={600}>{t('userProfile.enableNotifications')}</Typography>
            <Typography>{t('userProfile.receiveNotificationsAboutMaintenance')}</Typography>
          </div>
          <Tooltip title={t('generic.notificationPreferencesAutoSaved')} placement="top" arrow>
            <FormControlLabel
              control={
                <Switch
                  checked={isNotificationEnabled}
                  onChange={() => {
                    handleChangeNotifications();
                  }}
                />
              }
            />
          </Tooltip>
        </Box>

        <Divider sx={{ borderColor: 'var(--table-border)' }} />
      </SettingsCard>

      {isNotificationEnabled && (
        <Box sx={{ mt: 3 }}>
          <ComplexFilters />
        </Box>
      )}
    </>
  );
}

export default UserProfilNotification;
